import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import formatShort from '../../../../utils/formatShort';
export default function CustomerChart ({customers}: any) {


    const renderCustomizedLabel = (props: any) => {
        const { x, y, width, value } = props;
        const radius = 10;
    
        return (
          <g>
            <text
              x={x + width / 2}
              y={y - radius}
              fill="#323232"
              textAnchor="middle"
              dominantBaseline="middle"
            >
              {formatShort(value)}
            </text>
          </g>
        );
      };

    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={customers}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="account" />
          <YAxis tickFormatter={formatShort} />
          <Tooltip />
          <Bar dataKey="currCredit" fill="#8884d8" background={{ fill: '#eee' }} />
        </BarChart>
      </ResponsiveContainer>
    );
}
